import {
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";

import { takeUntil } from "rxjs/operators";

/**
 * Extending this will give you the ngModel + FormControl logic
 * You still need to add the following to your component providers:
 */
// {
// 	provide: NG_VALUE_ACCESSOR,
// 	useExisting: forwardRef(() => MyFormControlComponent),
// 	multi: true
// }

@Directive()
export abstract class AbstractFormControlComponent<T>
  implements ControlValueAccessor, OnDestroy {
  @Input()
  get value(): T {
    return this._value;
  }
  set value(val: T) {
    if (val === this._value) {
      return;
    }
    this._value = val;
    this.valueChange.emit(this._value);
  }
  protected _value: T;

  @Output()
  valueChange = new EventEmitter<T>();

  protected onTouched = new EventEmitter<void>();

  constructor() {
    this.initControlValueAccessor();
  }

  protected onDestroyEmitter = new EventEmitter<void>();
  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
  }

  private initControlValueAccessor(): void {
    this.valueChange.pipe(takeUntil(this.onDestroyEmitter)).subscribe((val) => {
      if (this._onChange == null) {
        return;
      }
      this._onChange(val);
    });
  }

  writeValue(val: T): void {
    this.value = val;
  }

  private _onChange?: (val: T) => void;
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(): void {
    return;
  }
}
